import React from "react";

import { SubscriptionsPanel } from "../../components/subscription/index.js";

export default () => <SubscriptionsPanel />;
